const zones = [
  { name: "Strasbourg", href: "/", color: "bg-rose-50", detail: "Intervention sous 24h" },
  { name: "Haguenau", href: "/reparation-fenetre-haguenau", color: "bg-emerald-50", detail: "Intervention sous 48h" },
  { name: "Schiltigheim", href: "/reparation-fenetre-schiltigheim", color: "bg-rose-50", detail: "Intervention sous 24h" },
  { name: "Illkirch", href: "/reparation-fenetre-illkirch-graffenstaden", color: "bg-orange-50", detail: "Intervention sous 24h" },
  { name: "Sélestat", href: "/reparation-fenetre-selestat", color: "bg-rose-50", detail: "Intervention sous 48h" },
  { name: "Tout le Bas-Rhin", href: "/zones-dinterventions", color: "bg-plum", detail: "Devis gratuit partout", textWhite: true },
];

export default function Zones() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <div>
            <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
              Zones d'intervention
            </p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum leading-tight">
              <span className="font-serif italic">Strasbourg</span> et tout le Bas-Rhin
            </h2>
          </div>
          <div className="mt-4 md:mt-0 w-4 h-4 rounded-full bg-coral shrink-0" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {zones.map((z) => (
            <a
              key={z.name}
              href={z.href}
              className={`${z.color} rounded-2xl overflow-hidden border border-rose-200 ${z.textWhite ? "border-none" : ""} block hover:shadow-md transition-shadow`}
            >
              <div className="p-6 md:p-8 min-h-[160px] flex items-center justify-center">
                <h3 className={`font-serif italic text-2xl md:text-3xl font-bold text-center ${z.textWhite ? "text-white" : "text-plum"}`}>
                  {z.name}
                </h3>
              </div>
              <div className={`px-6 py-4 ${z.textWhite ? "bg-white/10" : "bg-white"}`}>
                <p className={`text-sm font-medium ${z.textWhite ? "text-white/90" : "text-plum-dark"}`}>
                  {z.detail}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}